import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ReactPlaceholder from 'react-placeholder';
import ThemeContext from '../../providers/ThemeProvider';

const SeoText = ({ text, title }) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className="seo-container">
        <h1 className="seo-title">
          <ReactPlaceholder
            ready={title}
            rows={1}
            style={{ width: 90 }}
            type="text"
          >
            {title}
          </ReactPlaceholder>
        </h1>
        <div className="seo-text">
          <ReactPlaceholder ready={text} rows={6} type="text">
            <div dangerouslySetInnerHTML={{ __html: text }} />
          </ReactPlaceholder>
        </div>
      </div>
      <style jsx>{`
        .seo-container {
          position: relative;
        }
        .seo-title {
          color: ${theme.colors.headingtext};
          font-size: 22px;
          line-height: 22px;
          margin-bottom: 5px;
          padding: ${theme.padding.seotitlemobile
            ? theme.padding.seotitlemobile
            : '16px 16px 0px 16px'};
          text-align: left;
          text-transform: capitalize;
        }
        .seo-text {
          color: ${theme.colors.bodytext};
          font-size: 11px;
          margin-bottom: 15px;
          padding: 0px 16px;
          text-align: left;
          line-height: 1.25em;
        }
        @media (min-width: ${theme.breakpoints.mdUp}) {
          .seo-title {
            font-size: 26px;
            line-height: 26px;
            padding: 15px 15px 0px 15px;
          }
          .seo-text {
            font-size: 16px;
            margin-bottom: 15px;
            padding: 0px 15px;
          }
        }
        @media (min-width: ${theme.breakpoints.xlUp}) {
          .seo-text {
            font-size: 16px;
          }
        }
      `}</style>
    </>
  );
};

export default SeoText;

SeoText.propTypes = {
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
